import React from 'react';
import styles from './PurposeProject.module.scss'

const PurposeProject = () => {
    return (
        <div className={styles.container}>
            <div className={styles.textBlock}>
                <h2 className={styles.title}>ЦЕЛЬ ПРОЕКТА</h2>
                <p className={styles.text}>
                    Обеспечить участникам СВО возможность реализации своего потенциала в системе государственного и
                    муниципального управления региона, реальном секторе экономики
                </p>
            </div>
            <div className={styles.cardModule}>
                <div className={styles.card}>
                    <p className={styles.blackText}>Старт проекта</p>
                    <span className={styles.redText}>17 февраля 2025</span>
                </div>

                <div className={styles.card}>
                    <p className={styles.blackText}>Регистрация и подача заявки на участие в проекте</p>
                    <span className={styles.redText}>до 31 марта 2025</span>
                </div>

                <div className={styles.card}>
                    <p className={styles.blackText}>Отбор участников</p>
                    <span className={styles.redText}>до 1 июля 2025</span>
                </div>

                <div className={styles.card}>
                    <p className={styles.blackText}>Начало обучения для участников, прошедших отбор</p>
                    <span className={styles.redText}>1 августа 2025</span>
                </div>
            </div>
        </div>
    )
};

export default PurposeProject;